import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomSelectionDropdown from "../../../../controls/CustomSelectionDropdown";
import CustomButton from "../../../../controls/CustomButton";
import { addConsultationFeedback } from "../../../../../dispatchers/patientDispatchers";
import useTitanApp from "../../../../../hooks/useTitanApp";

export default function FeedbackButton({ isDarkMode }) {
  const [showDialog, setShowDialog] = useState(false);
  const [feedbackAbout, setFeedbackAbout] = useState(1);
  const [feedbackText, setFeedbackText] = useState("");
  const { patientState, templateState } = useTitanApp();

  const {
    consultationId,
    transcript,
    demDxSummaryText,
    demDxSummary,
    patientSummary,
    selectedPatientConsultation
  } = patientState || {};
  const { streamedText } = templateState || {};
  const feedbackAboutOptions = [
    { value: 1, label: "Summary" },
    { value: 2, label: "Actions" },
  ];

  const handleCancel = () => {
    setShowDialog(false);
    setFeedbackText("");
    setFeedbackAbout(1);
  };

  const handleSubmit = () => {
    addConsultationFeedback({
      consultationId,
      feedbackType: feedbackAbout,
      feedback: feedbackText,
      transcription: transcript,
      summary: demDxSummary === "" ? streamedText : demDxSummaryText,
      actions: patientSummary?.Actions || [],
    });

    handleCancel();
  };

  return (
    <>
      <button
        className={`feedback-trigger ${isDarkMode ? "dark" : "light"}`}
        onClick={() =>{
          if (selectedPatientConsultation?.consultationStatus === 1) return;
           setShowDialog(true

           )}}
      >
        <MessageSquare className="icon" />
      </button>

      <Modal
        open={showDialog}
        onClose={handleCancel}
        aria-labelledby="feedback-modal-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
            color: isDarkMode ? "#fff" : "#000",
            width: 500,
            borderRadius: 2,
            p: 3,
            boxShadow: 24,
            position: "relative",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCancel}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon sx={{ color: isDarkMode ? "#fff" : "#000" }} />
          </IconButton>

          <Typography
            id="feedback-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Provide Feedback
          </Typography>

          <div className="form-group">
            <CustomSelectionDropdown
              label="Feedback is about"
              name="feedbackAbout"
              value={feedbackAbout}
              options={feedbackAboutOptions}
              onChange={(e) => setFeedbackAbout(e.target.value)}
            />
          </div>

          <div
            className="form-group feedback-form-group"
            style={{ marginTop: "16px" }}
          >
            <label>Your feedback</label>
            <textarea
              className="template_input text_input_field"
              placeholder="Type your consultation notes here"
              autoComplete="off"
              value={feedbackText}
              maxLength={1000}
              onChange={(e) => setFeedbackText(e.target.value)}
            />
            <p className="char-counter">{feedbackText.length}/1000</p>
          </div>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              mt: 3,
            }}
          >
            <CustomButton
              type="button"
              action={handleCancel}
              label="Cancel"
              variant="outlined"
              className={`btn-cancel ${isDarkMode ? "dark" : "light"}`}
            />
            <CustomButton
              type="button"
              action={handleSubmit}
              label="Submit Feedback"
              disabled={!feedbackText.trim()}
              className={`btn-submit ${isDarkMode ? "dark" : "light"}`}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
}
